import { zodResolver } from '@hookform/resolvers/zod'
import { useForm, UseFormProps } from 'react-hook-form'
import { z } from 'zod'

import { makeGenericZodErrorMessage } from '@/utils/make-generic-zod-error-message'

const schema = z.object({
  planting_type: z.enum(
    ['convencional', 'duplo_alternado', 'meiosi'],
    makeGenericZodErrorMessage('A seleção do tipo de plantio é obrigatório.'),
  ),
  planting_space: z.number().min(1, 'O espaçamento é obrigatório.'),
  cane_cycle_type: z.enum(
    ['nao_especificado', 'cana_planta', 'cana_soca'],
    makeGenericZodErrorMessage(
      'A seleção do tipo de ciclo de cana é obrigatório.',
    ),
  ),
})

export type DefaultPlantingFailureFormData = z.infer<typeof schema>

export const usePlantingFailureForm = (
  props?: UseFormProps<DefaultPlantingFailureFormData>,
) => {
  const methods = useForm<DefaultPlantingFailureFormData>({
    resolver: zodResolver(schema),
    ...props,
  })

  return methods
}
